import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useState } from 'react';
import classNames from 'classnames';
import styles from './ShowMoreDetails.module.scss';
const ShowMoreDetails = ({ items = [], collapsedLabel = '', expanded: _expanded = false, className = '', }) => {
    const [expanded, setExpanded] = useState(_expanded);
    function handleOpen() {
        setExpanded(!expanded);
    }
    if (!items.length) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: !expanded ? (_jsx("div", Object.assign({ className: styles.button, onClick: handleOpen }, { children: collapsedLabel || items[0].value }))) : (items.map((item, index) => (_jsxs("div", Object.assign({ className: styles.line }, { children: [item.leftLabel && _jsxs("span", Object.assign({ className: styles.label }, { children: [item.leftLabel, " \u2022"] })), _jsx("span", Object.assign({ className: styles.value }, { children: item.value })), item.rightLabel && _jsxs("span", Object.assign({ className: styles.label }, { children: [" \u2022 ", item.rightLabel] }))] }), item.id || [index, ...Object.values(item)].join('_'))))) })));
};
export default memo(ShowMoreDetails);
